<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center">
    <div class="text-center">
      <h1 class="text-5xl font-bold text-blue-600 mb-4">Alessandro Chuy</h1>
      <p class="text-xl text-gray-500 mb-8">
        Rails · Vue · Tailwind all working 🎉
      </p>
      <div class="flex gap-4 justify-center">
        <button
          class="bg-blue-600 text-white px-6 py-3 rounded-xl font-semibold hover:bg-blue-700 transition"
          @click="count++"
        >
          Clicked {{ count }} times
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
const count = ref(0);
</script>
